<template>
    <div ref="exportView" v-if="exportData">
        <b-card
                no-body
                header-bg-variant="primary"
                class="text-secondary-light header-text text-right"
        >
            <img src="../../../assets/colab-logo.svg" height="100" width="100" alt="coLab" class="logo" slot="header">
            <h3 slot="header" style="font-weight: normal">enaio® coLab</h3>

            <b-card-body class="text-left">
                <label><strong>{{ $t('project.projectdetails') }}</strong></label>
                <table class="table table-condensed" style="width: 100%;">
                    <tbody>
                    <tr>
                        <td class="text-dark">{{ $t('project.settings.general.name') }}:</td>
                        <td>
                            <b-form-textarea
                                    v-model="exportData.name"
                                    :rows="exportData.name.length % 95 > 0 ? Math.floor(exportData.name.length/95) + 1 : Math.floor(exportData.name.length/95)"
                                    :max-rows="4"
                                    :disabled="true"
                                    :placeholder="$t('project.settings.general.namePlaceholder')">
                            </b-form-textarea>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-dark">{{ $t('project.settings.general.description') }}:</td>
                        <td>
                            <b-form-textarea
                                v-model="exportData.description"
                                :rows="exportData.description.length % 95 > 0 ? Math.floor(exportData.description.length/95) + 1 : Math.floor(exportData.description.length/95)"
                                :max-rows="12"
                                :disabled="true"
                                :placeholder="$t('project.settings.general.descriptionPlaceholder')">
                            </b-form-textarea>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-dark">{{ $t('general.about.componentVersion') }}:</td>
                        <td>{{ exportData.componentVersion }}</td>
                    </tr>
                    <tr>
                        <td class="text-dark">{{ $t('general.about.productVersion') }}:</td>
                        <td>{{ exportData.productVersion }}</td>
                    </tr>
                    <tr>
                        <td class="text-dark">{{ $t('general.about.manufacturer') }}:</td>
                        <td>{{ $t('general.about.manufacturerText') }}</td>
                    </tr>
                    </tbody>
                </table>
                <b-form novalidate>
                    <b-form-group v-if="exportData.members">
                        <label><strong>{{ $t('project.projectmembers') }}</strong></label>
                        <table class="table table-hover">
                            <tbody>
                            <tr v-for="member in exportData.members" :key="member.id">
                                <td>
                                    <div class="text-info font-weight-bold">{{ member.displayName }}</div>
                                    <div class="text-muted small">{{ member.email }}</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-form-group>
                </b-form>
                <div v-if="exportData.taskLists" class="html2pdf__page-break"/>
                <hr v-if="exportData.taskLists">
                <section class="pdf-item">
                    <label v-if="exportData.taskLists"><strong>{{ $t('menu.hover.tasks') }}</strong></label>
                </section>
                <export-project-tasks v-if="exportData.taskLists" :exportTasks="exportData.taskLists"></export-project-tasks>
                <div v-if="exportData.messages" class="html2pdf__page-break"/>
                <hr v-if="exportData.messages">
                <section class="pdf-item">
                    <label v-if="exportData.messages"><strong>{{ $t('project.projectmessages') }}</strong></label>
                </section>
                <project-feed v-if="exportData.messages" :exportFeed="exportData.messages"
                              :forExport="true"></project-feed>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import ProjectFeed from "../Home/Feed/ProjectFeed";
    import ExportProjectTasks from "./ExportProjectTasks";

    export default {
        name: 'export-contents-dialog',
        components: {ExportProjectTasks, ProjectFeed},
        props: ['exportData'],

        data() {
            return {}
        },

        mounted() {
            if (this.exportData) {
                console.log('export data: ', this.exportData);
            }
        },

        methods: {}

    }
</script>

<style scoped>
    .export-modal .modal-dialog {
        max-width: 80%;
    }
</style>
